import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Container, Link, Typography } from "@mui/material";
import { ForgetPasswordForm } from "../sections/auth";
import { styled } from "@mui/material/styles";
import ROUTES from "../routes/routes";

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

export default function ForgotPasswordPage() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title> Esqueceu sua senha | Orbis </title>
      </Helmet>

      <Container maxWidth="sm">
        <StyledContent>
          <Typography variant="h4" gutterBottom>
            Esqueceu sua senha
          </Typography>

          <Typography sx={{ mb: 5 }} variant="body2">
            Enter your email address or{" "}
            <Link onClick={() => navigate(ROUTES.login)} variant="subtitle2">
              Conecte-se
            </Link>
          </Typography>

          <ForgetPasswordForm />
        </StyledContent>
      </Container>
    </>
  );
}
